<h2>{{'error404' | translate}}</h2>
<h2>{{'pageNotFound' | translate}}</h2>
